function inputAdjoin({ prefix, suffix }) {
  if (prefix && suffix) {
    return "both";
  }
  if (prefix) {
    return "left";
  }
  if (suffix) {
    return "right";
  }
  return void 0;
}
export {
  inputAdjoin
};
